// GENERATED by tools/build_score_ts.py from the transcription in
// nsm-sight-reading/scores/src/g-major-run.json — do not edit here.
// Every note carries an absolute start and duration in quarter notes, so
// the engraving and the playback clock cannot disagree about timing.
import type { Score } from "@/courses/sight-reading/types";

export const gMajorRun: Score = {
  slug: "g-major-run",
  n: 3,
  title: "G Major Run",
  composer: "Jason Zac",
  rights: "original",
  publicSafe: true,
  key: "G",
  fifths: 1,
  time: [4, 4],
  tempo: 96,
  staves: 1,
  clefs: ["treble"],
  bars: 8,
  barQuarters: 4.0,
  lowest: 55,
  highest: 72,
  hasLyrics: false,
  jasonNote: "This is a melody I wrote on the key of G Major. It will also train you to run up and down scales which is very important as a Piano player. Watch your finger positions. On the way up, use the thumb under the other fingers and cross fingers over the thumb on the way down.",
  teaches: [
    "scale runs up and down",
    "thumb under on the way up",
    "crossing over the thumb on the way down",
    "one sharp \u2014 F sharp"
  ],
  art: "/sight-reading/art/g-major-run.jpg",
  artRights: "stock",
  background: "/sight-reading/bg/g-major-run.jpg",
  notes: [
    { bar: 1, hand: "rh", start: 0.0, dur: 1.0, midi: 71, pitch: "B4", d: "quarter" },
    { bar: 1, hand: "rh", start: 1.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter" },
    { bar: 1, hand: "rh", start: 2.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter" },
    { bar: 1, hand: "rh", start: 3.0, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 1, hand: "rh", start: 3.5, dur: 0.5, midi: 71, pitch: "B4", d: "eighth" },
    { bar: 2, hand: "rh", start: 4.0, dur: 1.0, midi: 72, pitch: "C5", d: "quarter" },
    { bar: 2, hand: "rh", start: 5.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter" },
    { bar: 2, hand: "rh", start: 6.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter" },
    { bar: 2, hand: "rh", start: 7.0, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 2, hand: "rh", start: 7.5, dur: 0.5, midi: 71, pitch: "B4", d: "eighth" },
    { bar: 3, hand: "rh", start: 8.0, dur: 0.5, midi: 72, pitch: "C5", d: "eighth" },
    { bar: 3, hand: "rh", start: 8.5, dur: 0.5, midi: 71, pitch: "B4", d: "eighth" },
    { bar: 3, hand: "rh", start: 9.0, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 3, hand: "rh", start: 9.5, dur: 0.5, midi: 67, pitch: "G4", d: "eighth" },
    { bar: 3, hand: "rh", start: 10.0, dur: 0.5, midi: 66, pitch: "F#4", d: "eighth" },
    { bar: 3, hand: "rh", start: 10.5, dur: 0.5, midi: 64, pitch: "E4", d: "eighth" },
    { bar: 3, hand: "rh", start: 11.0, dur: 0.5, midi: 62, pitch: "D4", d: "eighth" },
    { bar: 3, hand: "rh", start: 11.5, dur: 0.5, midi: 60, pitch: "C4", d: "eighth" },
    { bar: 4, hand: "rh", start: 12.0, dur: 0.5, midi: 59, pitch: "B3", d: "eighth" },
    { bar: 4, hand: "rh", start: 12.5, dur: 0.5, midi: 60, pitch: "C4", d: "eighth" },
    { bar: 4, hand: "rh", start: 13.0, dur: 0.5, midi: 62, pitch: "D4", d: "eighth" },
    { bar: 4, hand: "rh", start: 13.5, dur: 0.5, midi: 64, pitch: "E4", d: "eighth" },
    { bar: 4, hand: "rh", start: 14.0, dur: 0.5, midi: 66, pitch: "F#4", d: "eighth" },
    { bar: 4, hand: "rh", start: 14.5, dur: 0.5, midi: 67, pitch: "G4", d: "eighth" },
    { bar: 4, hand: "rh", start: 15.0, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 4, hand: "rh", start: 15.5, dur: 0.5, midi: 72, pitch: "C5", d: "eighth" },
    { bar: 5, hand: "rh", start: 16.0, dur: 1.0, midi: 71, pitch: "B4", d: "quarter" },
    { bar: 5, hand: "rh", start: 17.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter" },
    { bar: 5, hand: "rh", start: 18.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter" },
    { bar: 5, hand: "rh", start: 19.0, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 5, hand: "rh", start: 19.5, dur: 0.5, midi: 71, pitch: "B4", d: "eighth" },
    { bar: 6, hand: "rh", start: 20.0, dur: 1.0, midi: 72, pitch: "C5", d: "quarter" },
    { bar: 6, hand: "rh", start: 21.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter" },
    { bar: 6, hand: "rh", start: 22.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter" },
    { bar: 6, hand: "rh", start: 23.0, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 6, hand: "rh", start: 23.5, dur: 0.5, midi: 71, pitch: "B4", d: "eighth" },
    { bar: 7, hand: "rh", start: 24.0, dur: 0.5, midi: 72, pitch: "C5", d: "eighth" },
    { bar: 7, hand: "rh", start: 24.5, dur: 0.5, midi: 71, pitch: "B4", d: "eighth" },
    { bar: 7, hand: "rh", start: 25.0, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 7, hand: "rh", start: 25.5, dur: 0.5, midi: 67, pitch: "G4", d: "eighth" },
    { bar: 7, hand: "rh", start: 26.0, dur: 0.5, midi: 66, pitch: "F#4", d: "eighth" },
    { bar: 7, hand: "rh", start: 26.5, dur: 0.5, midi: 64, pitch: "E4", d: "eighth" },
    { bar: 7, hand: "rh", start: 27.0, dur: 0.5, midi: 66, pitch: "F#4", d: "eighth" },
    { bar: 7, hand: "rh", start: 27.5, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 8, hand: "rh", start: 28.0, dur: 1.0, midi: 67, pitch: "G4", d: "quarter" },
    { bar: 8, hand: "rh", start: 29.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter" },
    { bar: 8, hand: "rh", start: 30.0, dur: 2.0, midi: 55, pitch: "G3", d: "half" },
  ],
};
